import { environment } from 'nsdi-volto-frontend/config/environments';

// Per-page branding images. Same object_browser shape the Data Manager Admin
// block uses, but stored on the block so each search page can have its own.
// Leaving one unset falls back to the site-wide image (see utils/blockImage.ts).
const imageBrowserField = {
  widget: 'object_browser' as const,
  mode: 'image',
  type: 'object',
  selectedItemAttrs: ['Title', '@id', '@type', 'image_field', 'image_scales'],
  allowExternals: false,
};

const VoyagerSearchDetailsPageBlockSchema = {
  title: 'Voyager Search Details Page',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['itemId', 'returnUrl', 'showMap', 'showKeywords'],
    },
    {
      id: 'api',
      title: 'API Configuration',
      fields: ['voyagerBaseUrl', 'voyagerConfigId'],
    },
    {
      id: 'agol',
      title: 'AGOL',
      fields: ['arcgisUrl', 'agolEligibleFormats'],
    },
    {
      id: 'branding',
      title: 'Branding',
      fields: ['thumbnailImage', 'headerBanner'],
    },
    {
      id: 'display',
      title: 'Display Options',
      fields: ['defaultTab', 'maxKeywords'],
    },
  ],
  properties: {
    thumbnailImage: {
      title: 'Page Logo',
      description:
        'Logo shown beside the search bar on this page. Leave empty to use the site-wide thumbnail.',
      ...imageBrowserField,
    },
    headerBanner: {
      title: 'Header Banner',
      description:
        'Full-width banner behind the header on this page. Leave empty to use the site-wide banner.',
      ...imageBrowserField,
    },

    arcgisUrl: {
      title: 'ArcGIS Online URL',
      description:
        'Base URL of the ArcGIS Online instance, e.g. https://geoplatform.maps.arcgis.com/home/index.html. Drives the Open in AGOL action on this page.',
      type: 'string',
    },
    voyagerBaseUrl: {
      title: 'Voyager API Base URL',
      description:
        'The base URL for the Voyager Search API. Options: https://odn.voyagersearch.com, https://ogc-sdi.voyagersearch.com, https://voyager.fas.usda.gov/voyager',
      type: 'string',
      default: environment.voyager.baseUrl,
    },
    voyagerConfigId: {
      title: 'Voyager Config ID',
      description:
        'The display configuration ID. Use D18D9C907361 for ODN, default for OGC-SDI, D176678659AD for USDA FAS',
      type: 'string',
      default: environment.voyager.configId,
    },
    itemId: {
      title: 'Item ID',
      description:
        'The ID of the item to display. If not provided, the ID will be extracted from the URL query parameter.',
      type: 'string',
    },
    returnUrl: {
      title: 'Return URL',
      description:
        'The URL to navigate back to when clicking "Return to Search". Defaults to browser history.',
      type: 'string',
    },
    showMap: {
      title: 'Show Map',
      description:
        'Display the geographic map when geographic data is available',
      type: 'boolean',
      default: true,
    },
    showKeywords: {
      title: 'Show Keywords',
      description: 'Display the keywords section',
      type: 'boolean',
      default: true,
    },
    defaultTab: {
      title: 'Default Tab',
      description: 'The tab to display by default',
      type: 'string',
      choices: [
        ['details', 'Details'],
        ['metadata', 'Metadata'],
      ],
      default: 'details',
    },
    maxKeywords: {
      title: 'Max Keywords',
      description: 'Maximum number of keywords to display (0 for unlimited)',
      type: 'number',
      default: 20,
    },
    agolEligibleFormats: {
      title: 'AGOL Eligible Formats',
      description:
        'Comma-separated dataset format values that show the "Open in AGOL" button (e.g., arcgis-map-server-layer, arcgis-feature-layer). Leave empty to use the default.',
      type: 'string',
      default: 'arcgis-map-server-layer',
    },
  },
  required: [],
};

export default VoyagerSearchDetailsPageBlockSchema;
